import store from "@/store";
import router from "@/router";
import {
  getModule,
  Module,
  MutationAction,
  VuexModule,
} from "vuex-module-decorators";
import common from "@/store/common/module/common";
import {
  AccessToken,
  LoginRequest,
  ValidationException,
  Menu,
  AuthContent,
} from "@/store/user/model/user";
import { doPost, doGet } from "@/store/common/module/apis";

@Module({
  namespaced: true,
  name: "auth",
  store,
  dynamic: true,
})
class AuthModule extends VuexModule {
  userId: string | null = null;
  token: string | null = null;
  menus: Menu[] = [];
  authContent: AuthContent | null = null;
  rights: string[] = [];

  get authToken(): string | null {
    return this.token;
  }

  @MutationAction
  async login(request: LoginRequest) {
    try {
      const response = await doPost("/auth/authorize", request);
      if (response) {
        const accessToken = response as AccessToken;
        this.userId = accessToken.user_id;
        this.token = accessToken.token;

        router.push("/dashboard");

        return {
          userId: this.userId,
          token: this.token,
        };
      } else {
        return {
          userId: null,
          token: null,
        };
      }
    } catch (error: any) {
      //common.context.commit("setLoading", false);
      common.setLoading(false);
      if (error.message) {
        common.setError(error.message);
      }
      return Promise.reject(error as ValidationException);
    }
  }

  @MutationAction
  async logout() {
    try {
      await doGet("/auth/signout");
      this.userId = null;
      this.token = null;
      this.menus = [];
      if (this.authContent) {
        this.authContent.user_id = null;
        this.authContent.token = null;
        this.authContent.adminOf = null;
        this.authContent.GOOGLE_MAP_KEY = null;
      }

      if (
        router.currentRoute.path != "/login" &&
        router.currentRoute.path != "/forgetpassword"
      )
        router.push("/login");

      common.setLoading(false);
      common.setError("");

      return { userId: "", token: "", authContent: {} };
    } catch (error: any) {
      this.userId = null;
      this.token = null;
      this.menus = [];
      if (this.authContent) {
        this.authContent.user_id = null;
        this.authContent.token = null;
        this.authContent.adminOf = null;
        this.authContent.GOOGLE_MAP_KEY = null;
      }
      common.setLoading(false);

      if (error.message) {
        common.context.commit("setError", error.message);
      }
      return Promise.reject(error as ValidationException);
    }
  }

  @MutationAction
  async doPreLogin() {
    console.log("doPreLogin");
    // console.log(this.authContent);

    try {
      this.authContent = await doGet("/api/o/webcontent");
      this.menus = await doGet("/api/menus");
      this.rights = await doGet("/api/myRights");
      router.push("/dashboard");
      return {
        menus: this.menus,
        authContent: this.authContent,
        token: this.authContent ? this.authContent.token : null,
        userId: this.authContent ? this.authContent.user_id : null,
        rights: this.rights,
      };
    } catch (error) {
      this.userId = null;
      this.token = null;
      this.menus = [];
      if (this.authContent) {
        this.authContent.user_id = null;
        this.authContent.token = null;
        this.authContent.adminOf = null;
        this.authContent.GOOGLE_MAP_KEY = null;
      }
      common.setError("");
      // await doGet("/auth/signout");
      return Promise.reject(error as ValidationException);
    }
  }

  @MutationAction
  async doPostLogin() {
    try {
      this.menus = await doGet("/api/menus");
      if (this.authContent == null) {
        try {
          this.authContent = await doGet("/api/o/webcontent");
          this.rights = await doGet("/api/myRights");
          if (
            this.authContent != null &&
            this.authContent.PAYMENT_REQUIRED != null &&
            this.authContent.PAYMENT_REQUIRED
          ) {
            const me: Menu[] = [];
            for (let i = 0; i < this.menus.length; i++) {
              /** TODO only free module */
              if (this.menus[i].to == "/account") {
                me.push(this.menus[i]);
              }
            }
            this.menus = me;
            if (window.location.href.indexOf("/account") == -1) {
              router.push("/account");
            }
          }
          return {
            menus: this.menus,
            authContent: this.authContent,
            token: this.authContent ? this.authContent.token : null,
            userId: this.authContent ? this.authContent.user_id : null,
            rights: this.rights,
          };
        } catch (error: any) {
          if (error.message) {
            common.setError(error.message);
          }
          return Promise.reject(error as ValidationException);
        }
      }
    } catch (error: any) {
      if (error.message) {
        common.setError(error.message);
      }
      if (
        router.currentRoute.path != "/login" &&
        router.currentRoute.path != "/forgetpassword"
      )
        router.push("/login");

      return Promise.reject(error as ValidationException);
    }
  }
}

export default getModule(AuthModule);
